import { usePostMutation } from "../../../hooks/useClientPortalQuery";
import { useClientPortalConfigContext } from "../../../context/ClientPortalConfig.ctx";
import { AxiosError } from "axios";
import { IdempotencyKeyModel, SetupSCAResult } from "types/generated/models";
import { RecaptchaAction } from "utils/recaptcha";

export function useSetupSCAIntent(publicId: string) {
    const { clientPortalGuid } = useClientPortalConfigContext();

    const { mutateAsync } = usePostMutation<SetupSCAResult, AxiosError, IdempotencyKeyModel>({
        url: `/api/v1/${clientPortalGuid}/Stripe/SetupSCAIntent?publicId=${publicId}`,
        recaptchaAction: RecaptchaAction.SaveCard,
    });

    return {
        setupSCAIntent: mutateAsync,
    };
}
